import { render, staticRenderFns } from "./CenteredLogo.vue?vue&type=template&id=3652bd26&scoped=true&"
import script from "./CenteredLogo.vue?vue&type=script&lang=js&"
export * from "./CenteredLogo.vue?vue&type=script&lang=js&"
import style0 from "./CenteredLogo.vue?vue&type=style&index=0&id=3652bd26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3652bd26",
  null
  
)

export default component.exports